var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ServiceDataBase } from "@/modules/services/models/ServiceData";
import { MapProperty, MapGetMethod, MapSetMethod } from "@/utils/mapper/ClassMapper";
import { SmartAd } from "./PublicDocumentSmartAd";
var Document = (function (_super) {
    __extends(Document, _super);
    function Document() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.organizationLogo = '';
        _this.organizationName = '';
        _this.organizationWebsite = '';
        _this.blockChainReceiptUrl = '';
        _this.blockChainReceipt2Url = '';
        _this.documentName = '';
        _this.documentImageUrl = '';
        _this.documentPdfUrl = '';
        _this.documentPublicPageUrl = '';
        _this.createDate = '';
        _this.documentId = '';
        _this.documentFileId = '';
        _this.emissionDate = '';
        _this.isBlockChain = false;
        _this.isBlockChainSigned = false;
        _this.isBlockChain2 = false;
        _this.isBlockChain2Signed = false;
        _this.isBlockChain2Approved = false;
        _this.isDocumentLandscape = false;
        _this.isDocumentSigned = false;
        _this.isDemo = false;
        _this.isPrivate = false;
        _this.isSuccess = false;
        _this.isPublicVisible = false;
        _this.errors = [];
        _this.isVerified = false;
        _this.keywords = '';
        _this.blockChainReceiptData = '';
        _this.originalDocumentImageUrl = '';
        _this.folderName = '';
        _this.folderTitle = '';
        _this.recipientPublicProfileUrl = '';
        _this.smartads = [];
        _this.recipientName = '';
        return _this;
    }
    Document.prototype.setData = function (data) {
        this.isPublicVisible = !this.isPrivate;
    };
    Document.prototype.getData = function () {
    };
    __decorate([
        MapProperty({ from: 'AcademyLogo' })
    ], Document.prototype, "organizationLogo", void 0);
    __decorate([
        MapProperty({ from: 'AcademyName' })
    ], Document.prototype, "organizationName", void 0);
    __decorate([
        MapProperty({ from: 'AcademyWebsite' })
    ], Document.prototype, "organizationWebsite", void 0);
    __decorate([
        MapProperty({ from: 'BlockChainReceiptUrl' })
    ], Document.prototype, "blockChainReceiptUrl", void 0);
    __decorate([
        MapProperty({ from: 'BlockChainReceipt2Url' })
    ], Document.prototype, "blockChainReceipt2Url", void 0);
    __decorate([
        MapProperty({ from: 'DocumentName' })
    ], Document.prototype, "documentName", void 0);
    __decorate([
        MapProperty({ from: 'CertificateImageUrl' })
    ], Document.prototype, "documentImageUrl", void 0);
    __decorate([
        MapProperty({ from: 'CertificatePdfUrl' })
    ], Document.prototype, "documentPdfUrl", void 0);
    __decorate([
        MapProperty({ from: 'CertificateUrl' })
    ], Document.prototype, "documentPublicPageUrl", void 0);
    __decorate([
        MapProperty({ from: 'DigitalDiplomaCreateDate' })
    ], Document.prototype, "createDate", void 0);
    __decorate([
        MapProperty({ from: 'DigitalDiplomaRowId' })
    ], Document.prototype, "documentId", void 0);
    __decorate([
        MapProperty({ from: 'DigitalDiplomaFileId' })
    ], Document.prototype, "documentFileId", void 0);
    __decorate([
        MapProperty({ from: 'EmissionDate' })
    ], Document.prototype, "emissionDate", void 0);
    __decorate([
        MapProperty({ from: 'IsBlockChain' })
    ], Document.prototype, "isBlockChain", void 0);
    __decorate([
        MapProperty({ from: 'IsBlockChainSigned' })
    ], Document.prototype, "isBlockChainSigned", void 0);
    __decorate([
        MapProperty({ from: 'IsBlockChain2' })
    ], Document.prototype, "isBlockChain2", void 0);
    __decorate([
        MapProperty({ from: 'IsBlockChain2Signed' })
    ], Document.prototype, "isBlockChain2Signed", void 0);
    __decorate([
        MapProperty({ from: 'IsBlockChain2Approved' })
    ], Document.prototype, "isBlockChain2Approved", void 0);
    __decorate([
        MapProperty({ from: 'IsCertificateLandscape' })
    ], Document.prototype, "isDocumentLandscape", void 0);
    __decorate([
        MapProperty({ from: 'IsCertificateSigned' })
    ], Document.prototype, "isDocumentSigned", void 0);
    __decorate([
        MapProperty({ from: 'IsDemo' })
    ], Document.prototype, "isDemo", void 0);
    __decorate([
        MapProperty({ from: 'IsPrivate' })
    ], Document.prototype, "isPrivate", void 0);
    __decorate([
        MapProperty({ from: 'IsSuccess' })
    ], Document.prototype, "isSuccess", void 0);
    __decorate([
        MapProperty({ from: 'ErrorList' })
    ], Document.prototype, "errors", void 0);
    __decorate([
        MapProperty({ from: 'IsVerified' })
    ], Document.prototype, "isVerified", void 0);
    __decorate([
        MapProperty({ from: 'KeyWords' })
    ], Document.prototype, "keywords", void 0);
    __decorate([
        MapProperty({ from: 'MyValidateBlockChainReceiptData' })
    ], Document.prototype, "blockChainReceiptData", void 0);
    __decorate([
        MapProperty({ from: 'OgImageUrl' })
    ], Document.prototype, "originalDocumentImageUrl", void 0);
    __decorate([
        MapProperty({ from: 'ProgramName' })
    ], Document.prototype, "folderName", void 0);
    __decorate([
        MapProperty({ from: 'ProgramTitle' })
    ], Document.prototype, "folderTitle", void 0);
    __decorate([
        MapProperty({ from: 'PublicProfileUrl' })
    ], Document.prototype, "recipientPublicProfileUrl", void 0);
    __decorate([
        MapProperty({ from: 'SmartAdds', isArray: true, type: SmartAd })
    ], Document.prototype, "smartads", void 0);
    __decorate([
        MapProperty({ from: 'StudentName' })
    ], Document.prototype, "recipientName", void 0);
    __decorate([
        MapSetMethod()
    ], Document.prototype, "setData", null);
    __decorate([
        MapGetMethod()
    ], Document.prototype, "getData", null);
    return Document;
}(ServiceDataBase));
export { Document };



//////////////////
// WEBPACK FOOTER
// ./src/modules/documents/models/Document.ts
// module id = null
// module chunks = 